import { createSelector } from '@ngrx/store';
import { availablePickupsState } from '../root';

export const hasAlreadyCalculatedPickupTimesForSomeLocations = createSelector(availablePickupsState, (availablePickups) =>
    availablePickups.some((item) => item.calculatedDate !== null),
);
